import { RenderableBase } from './renderable-base';

export class RenderableCheckbox extends RenderableBase<boolean> {
}
